import { useTranslation } from 'react-i18next'

import ThirdPartyForm from '@pages/tag/_shared/components/ThirdPartyForm'
import SectionTitle from '@shared/ui/SectionTitle'

const ThirdParty = () => {
  const { t } = useTranslation(['tag'])

  return (
    <>
      <SectionTitle title={t('tag:create_step_2_fill_tag_information')} />
      <ThirdPartyForm />
    </>
  )
}

export default ThirdParty
